import { render } from "./LessonForm.vue?vue&type=template&id=5a700c70&scoped=true"
import script from "./LessonForm.vue?vue&type=script&lang=js"
export * from "./LessonForm.vue?vue&type=script&lang=js"

import "./LessonForm.vue?vue&type=style&index=0&id=5a700c70&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a700c70"]])

export default __exports__